import React, { useState, useEffect } from 'react';
import Navbar from '../components/navbar/Navbar';
import Hero from '../components/hero/Hero';
import Footer from '../components/footer/Footer';
import { useNavigate } from 'react-router-dom';
import { db, auth, provider } from '../firebase/Firebase';
import { collection, getDocs } from 'firebase/firestore';
import { signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { QRCodeSVG } from 'qrcode.react'; // Updated to import QRCodeSVG

const Home = () => {
    const [showDialog, setShowDialog] = useState(false);
    const [password, setPassword] = useState('');
    const [user, setUser] = useState(null);
    const [applicationExists, setApplicationExists] = useState(false);
    const [amount, setAmount] = useState('');
    const [upiUrl, setUpiUrl] = useState('');
    const navigate = useNavigate();

    const handleAdminAccess = (event) => {
        if (event.ctrlKey && event.altKey) {
            setShowDialog(true);
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleAdminAccess);
        return () => {
            document.removeEventListener('keydown', handleAdminAccess);
        };
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                checkApplicationStatus(currentUser.email);
            }
        });
        return () => unsubscribe();
    }, []);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmitPassword = (e) => {
        e.preventDefault();
        if (password === '290309') {
            alert('Access granted to the admin panel!');
            navigate('/admin');
            setShowDialog(false);
        } else {
            alert('Access denied!');
        }
    };

    const loginWithGoogle = async () => {
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error('Error logging in:', error);
        }
    };

    const checkApplicationStatus = async (email) => {
        const querySnapshot = await getDocs(collection(db, 'staffApplications'));
        const applications = querySnapshot.docs.map(doc => doc.data());
        const userApplication = applications.find(app => app.email === email);
        setApplicationExists(!!userApplication);
    };

    const handleSendApplication = () => {
        if (applicationExists) {
            navigate('/application-status');
        } else {
            navigate('/form');
        }
    };

    const generateUpiUrl = () => {
        if (!amount || isNaN(amount)) {
            alert('Please enter a valid amount');
            return;
        }
        const upi = `upi://pay?pa=7984645967@ptsbi&pn=PowerGames Network&am=${amount}&cu=INR`;
        setUpiUrl(upi);
    };

    return (
        <div style={{ backgroundColor: '#121212', color: '#fff' }}>
            <Navbar />
            <Hero />

            {/* Welcome to PowerGames Section */}
            <div style={{ backgroundColor: '#2e2e2e', padding: '40px', textAlign: 'center' }}>
                <h1 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '20px' }}>Welcome To PowerGames Server</h1>
                <p style={{ marginBottom: '20px', fontSize: '1.2rem' }}>
                    Join us in an exhilarating gaming experience like never before!
                </p>

                {/* Info Boxes */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '20px',
                    marginBottom: '40px',
                    flexWrap: 'wrap'
                }}>
                    {/* Help Box */}
                    <div style={{
                        border: '2px solid white',
                        padding: '20px',
                        width: '200px',
                        textAlign: 'center',
                        transition: 'transform 0.3s',
                        cursor: 'pointer',
                    }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h3 style={{ fontWeight: 'bold' }}>Help</h3>
                        <p>Feel free to reach out to our team for any assistance or queries you may have!</p>
                    </div>
                    {/* Discord Box */}
                    <div style={{
                        border: '2px solid white',
                        padding: '20px',
                        width: '200px',
                        textAlign: 'center',
                        transition: 'transform 0.3s',
                        cursor: 'pointer',
                    }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h3 style={{ fontWeight: 'bold' }}>Discord</h3>
                        <p>Join our Discord for the latest updates and uptime notifications!</p>
                    </div>
                    {/* Jobs Box */}
                    <div style={{
                        border: '2px solid white',
                        padding: '20px',
                        width: '200px',
                        textAlign: 'center',
                        transition: 'transform 0.3s',
                        cursor: 'pointer',
                    }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h3 style={{ fontWeight: 'bold' }}>Jobs</h3>
                        <p>Join our team to help our server grow and thrive!</p>
                    </div>
                </div>
            </div>

            {/* FAQ Section */}
            <div style={{ backgroundColor: '#333', padding: '40px', textAlign: 'center' }}>
                <h2 style={{ color: '#FF9A00', fontSize: '2.5rem', marginBottom: '20px' }}>FAQ</h2>

                {/* FAQ 1 */}
                <div style={{ marginBottom: '20px' }}>
                    <h3 style={{ fontWeight: 'bold', color: 'white' }}>How to Join the Server?</h3>
                    <p style={{ fontSize: '1.2rem', color: 'white' }}>
                        Download Minecraft, go to multiplayer, and add the server address: play.powergames.net
                    </p>
                </div>

                {/* FAQ 2 */}
                <div style={{ marginBottom: '20px' }}>
                    <h3 style={{ fontWeight: 'bold', color: 'white' }}>How to Join as Staff?</h3>
                    <p style={{ fontSize: '1.2rem', color: 'white' }}>
                        Fill out our staff application form, and we will review it.
                    </p>
                </div>

                {/* Redirect Button to FAQ */}
                <button
                    onClick={() => navigate('/faq')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#FF9A00',
                        color: 'black',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '1rem',
                    }}
                >
                    See More
                </button>
            </div>

            {/* Donation Section */}
            <div style={{ backgroundColor: '#FF9A00', padding: '40px', color: 'black', textAlign: 'center' }}>
                <h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>Donation</h2>
                <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
                    At PowerGames, we are committed to providing an exceptional gaming experience to our community. Currently, we host our server on Aternos, which allows us to offer a platform for players to enjoy their favorite games. However, due to financial constraints and limited resources, we face challenges in scaling our server and accommodating a growing player base. To ensure the best possible experience, we rely on the generosity of our community to help us improve our services. Your support is invaluable in enhancing server performance and maintenance. We invite you to contribute through donations via GPay or any UPI service. Every contribution, no matter how small, makes a significant impact on our ability to maintain and upgrade the server. Together, we can build a thriving gaming community. Thank you for your support!
                </p>

                {/* UPI ID and Amount Input */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
                    <input
                        type="text"
                        placeholder="Enter Amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        style={{
                            padding: '10px',
                            borderRadius: '5px',
                            border: 'none',
                            marginRight: '10px',
                        }}
                    />
                    <button
                        onClick={generateUpiUrl}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#000',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        Generate QR Code
                    </button>
                </div>

                {/* QR Code Display */}
                {upiUrl && (
                    <div style={{ marginTop: '20px' }}>
                        <h3 style={{ color: '#333' }}>Scan this QR Code to Pay:</h3>
                        <QRCodeSVG value={upiUrl} size={128} /> {/* Changed to QRCodeSVG */}
                    </div>
                )}
            </div>

            {/* Apply For Staff - Dynamic Buttons */}
            <div style={{ backgroundColor: '#111111', padding: '40px', color: '#FF9A00', textAlign: 'center' }}>
                <h2 style={{ fontSize: '2rem', marginBottom: '20px' }}>Apply For Staff</h2>
                {!user ? (
                    <button onClick={loginWithGoogle} style={{
                        backgroundColor: 'red',
                        color: 'black',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                    }}>
                        Login to Send Application
                    </button>
                ) : (
                    <button onClick={handleSendApplication} style={{
                        backgroundColor: 'red',
                        color: '#000',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                    }}>
                        {applicationExists ? 'Check Application Status' : 'Send Application'}
                    </button>
                )}
            </div>

            {/* Admin Dialog */}
            {showDialog && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '10px',
                    zIndex: 1000,
                }}>
                    <h3>Enter Admin Password</h3>
                    <form onSubmit={handleSubmitPassword}>
                        <input
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            style={{ padding: '10px', marginBottom: '10px', width: '100%' }}
                            required
                        />
                        <button type="submit" style={{
                            padding: '10px 20px',
                            backgroundColor: '#FF9A00',
                            color: 'black',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}>
                            Submit
                        </button>
                    </form>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default Home;
